import React, { memo, useState } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { MDBRow, MDBCol } from "mdbreact";

import { Label, AbsDropDown, Input } from "abs-ui-components";
import { preventScientificNotation } from "../../../services/utilities";

const RegulationDetailsmFormGroup = (props) => {
	const ICECLASS_TYPE_OTHER = "other";
	const {
		control,
		formState: { errors },
		setValue,
	} = useFormContext();

	const [iceClassName, setIceClassName] = useState(
		"" || props?.vesselData?.IceClassMst?.Value
	);
	const { IceClassMst, PrimaryMonitoringMethodMst } = props.vesselData || {};

	const technicalEfficiencyOptions = props.masterData?.[4]
		?.GetTechnicalEfficiency
		? props.masterData[4]?.GetTechnicalEfficiency.map((e) => ({
				...e,
				label: e.Value,
				value: e.TechnicalEfficiencyMstId,
		  }))
		: [];

	const technicalEfficiencyOptions1 = props.masterData?.[4]
		?.GetTechnicalEfficiency
		? [
				{ label: "Please Select", value: "" },
				...props.masterData[4].GetTechnicalEfficiency.map((e) => ({
					...e,
					label: e.Value,
					value: e.TechnicalEfficiencyMstId,
				})),
		  ]
		: [];
	const iceClasses = props.masterData?.[3]?.GetIceClasses
		? props.masterData[3]?.GetIceClasses.map((e) => ({
				...e,
				value: e.Value,
				label: e.Value,
		  }))
		: [];

	const monitoringMethods = props.masterData?.[5]?.GetMonitoringMethod
		? props.masterData[5]?.GetMonitoringMethod.map((e) => ({
				...e,
				value: e.Value,
				label: e.Value,
		  }))
		: [];

	const enhancedIceClass = {
		...IceClassMst,
		value: IceClassMst?.Value,
		label: IceClassMst?.Value,
	};
	const enhancedMonitoringMethodPrimary = {
		...PrimaryMonitoringMethodMst,
		value: PrimaryMonitoringMethodMst?.Value,
		label: PrimaryMonitoringMethodMst?.Value,
	};

	const filteredTechnicalEfficiency =
		props.vesselMstId &&
		props?.vesselData?.VesselTechnicalEfficiencyDtls?.length > 0
			? technicalEfficiencyOptions.find(
					(item) =>
						item.TechnicalEfficiencyMstId ===
						props?.vesselData?.VesselTechnicalEfficiencyDtls[0]
							?.TechnicalEfficiencyMstId
			  )
			: {};

	const filteredTechnicalEfficiency1 =
		props.vesselMstId &&
		props?.vesselData?.VesselTechnicalEfficiencyDtls?.length > 1
			? technicalEfficiencyOptions.find(
					(item) =>
						item?.TechnicalEfficiencyMstId ===
						props?.vesselData?.VesselTechnicalEfficiencyDtls[1]
							?.TechnicalEfficiencyMstId
			  )
			: {};

	const [technicalEfficiencyId1, setTechnicalEfficiencyId1] = useState(
		null || filteredTechnicalEfficiency?.Value
	);
	const [technicalEfficiencyId2, setTechnicalEfficiencyId2] = useState(
		null || filteredTechnicalEfficiency1?.Value
	);

	if (technicalEfficiencyId2 === undefined) {
		setValue("technicalEfficiencyList.1.technicalEfficiencyText", "");
	}

	return (
		<div className="container-fluid p-0 m-0">
			<MDBRow>
				<MDBCol md="12" className="mt-3">
					<Label
						required
						bold
						name="Technical Efficiency1"
						className="mb-1"
					/>
					<MDBRow className="d-flex">
						<MDBCol
							md={
								technicalEfficiencyId1 !== "Not Applicable"
									? "6"
									: "12"
							}
						>
							<Controller
								name="technicalEfficiencyList.0.technicalEfficiencyMstId"
								control={control}
								rules={
									props?.regulations?.trim() !== "EUMRV" &&
									props?.regulations?.trim() !== "UKMRV" &&
									props?.regulations?.trim() !== "DCS"
										? {
												required:
													"Please select a technical efficiency category",
										  }
										: {}
								}
								defaultValue={
									props?.vesselMstId &&
									props?.vesselData
										?.VesselTechnicalEfficiencyDtls
										?.length > 0
										? {
												TechnicalEfficiencyMstId:
													props?.vesselData
														?.VesselTechnicalEfficiencyDtls[0]
														?.TechnicalEfficiencyMstId,
												value: props?.vesselData
													?.VesselTechnicalEfficiencyDtls[0]
													?.TechnicalEfficiencyMstId,
												label: filteredTechnicalEfficiency?.Value,
										  }
										: null
								}
								render={({ field }) => {
									return (
										<div id="vessel_technical_efficiency" name={field.name}>
											<AbsDropDown
												options={
													technicalEfficiencyOptions
												}
												selected={field.value?.value}
												handleChange={(
													selectedItem
												) => {
													setTechnicalEfficiencyId1(
														selectedItem.Value
													);
													field.onChange(
														selectedItem
													);
												}}
												placeholder="Please Select"
												disabled={
													!props.isEnrollVessel &&
													props.vesselMstId &&
													(props?.regulations?.trim() ===
														"EUMRV" ||
														"UKMRV" ||
														"DCS")
												}
											/>
										</div>
									);
								}}
							/>
							{errors.technicalEfficiencyList &&
								errors.technicalEfficiencyList[0] &&
								errors.technicalEfficiencyList[0]
									.technicalEfficiencyMstId && (
									<div className="error-msg">
										{
											errors.technicalEfficiencyList[0]
												.technicalEfficiencyMstId
												.message
										}
									</div>
								)}
						</MDBCol>
						{technicalEfficiencyId1 !== "Not Applicable" ? (
							<MDBCol md="6">
								<Controller
									name="technicalEfficiencyList.0.technicalEfficiencyText"
									control={control}
									rules={
										props?.regulations?.trim() !==
											"EUMRV" &&
										props?.regulations?.trim() !==
											"UKMRV" &&
										props?.regulations?.trim() !== "DCS"
											? {
													required: {
														message:
															"Please enter technical efficiency value",
														value:
															technicalEfficiencyId1 !==
																"Not Applicable" &&
															technicalEfficiencyId1 !==
																null,
													},
													validate: (value) => {
														if (value <= 0) {
															return "Please enter a value greater than zero.";
														}
														return true; // If the value is valid
													},
											  }
											: {}
									}
									defaultValue={
										props?.vesselMstId &&
										props?.vesselData
											?.VesselTechnicalEfficiencyDtls
											?.length > 0
											? props?.vesselData
													?.VesselTechnicalEfficiencyDtls[0]
													?.TechnicalEfficiencyText
											: null
									}
									render={({ field }) => (
										<Input
										name={field.name}
											id="vessel_technical_efficiency_value"
											autoFocus={false}
											value={field.value}
											onChange={(e) => field.onChange(e)}
											className="input-height"
											type="number"
											disabled={
												!props.isEnrollVessel &&
												props.vesselMstId &&
												(props?.regulations?.trim() ===
													"EUMRV" ||
													"UKMRV" ||
													"DCS")
											}
											onKeyDown={(e) => {
												preventScientificNotation(e);
												// Prevent up and down arrow keys
												if (
													e.key === "ArrowUp" ||
													e.key === "ArrowDown"
												) {
													e.preventDefault();
												}
											}}
											onWheel={(e) => e.target.blur()}
										/>
									)}
								/>
								{errors.technicalEfficiencyList &&
									errors.technicalEfficiencyList[0] &&
									errors.technicalEfficiencyList[0]
										.technicalEfficiencyText && (
										<div className="error-msg">
											{
												errors
													.technicalEfficiencyList[0]
													.technicalEfficiencyText
													.message
											}
										</div>
									)}
							</MDBCol>
						) : (
							""
						)}
					</MDBRow>
				</MDBCol>
				<MDBCol md="12" className="mt-3">
					<Label bold name="Technical Efficiency2" className="mb-1" />
					<MDBRow className="d-flex">
						<MDBCol
							md={
								technicalEfficiencyId2 !== "Not Applicable"
									? "6"
									: "12"
							}
						>
							<Controller
								name="technicalEfficiencyList.1.technicalEfficiencyMstId"
								control={control}
								rules={{}}
								defaultValue={
									props?.vesselMstId &&
									props?.vesselData
										?.VesselTechnicalEfficiencyDtls
										?.length > 1
										? {
												TechnicalEfficiencyMstId:
													props?.vesselData
														?.VesselTechnicalEfficiencyDtls[1]
														?.TechnicalEfficiencyMstId,
												value: props?.vesselData
													?.VesselTechnicalEfficiencyDtls[1]
													?.TechnicalEfficiencyMstId,
												label: filteredTechnicalEfficiency1?.Value,
										  }
										: null
								}
								render={({ field }) => (
									<div id="vessel_technical_efficiency1" name={field.name}>
										<AbsDropDown
											options={
												technicalEfficiencyOptions1
											}
											selected={field.value?.value}
											handleChange={(selectedItem) => {
												setTechnicalEfficiencyId2(
													selectedItem.Value
												);
												field.onChange(selectedItem);
											}}
											placeholder="Please Select"
											disabled={
												!props.isEnrollVessel &&
												props.vesselMstId &&
												(props?.regulations?.trim() ===
													"EUMRV" ||
													"UKMRV" ||
													"DCS")
											}
										/>
									</div>
								)}
							/>
							{errors.technicalEfficiency2 &&
								errors.technicalEfficiency2
									.efficiencyOption && (
									<div className="error-msg">
										{
											errors.technicalEfficiency2
												.efficiencyOption.message
										}
									</div>
								)}
						</MDBCol>
						{technicalEfficiencyId2 !== "Not Applicable" ? (
							<MDBCol md="6">
								<Controller
									name="technicalEfficiencyList.1.technicalEfficiencyText"
									control={control}
									defaultValue={
										props?.vesselMstId &&
										props?.vesselData
											?.VesselTechnicalEfficiencyDtls
											?.length > 1
											? props?.vesselData
													?.VesselTechnicalEfficiencyDtls[1]
													?.TechnicalEfficiencyText
											: null
									}
									render={({ field }) => (
										<Input
										name={field.name}
											id="vessel_technical_efficiency_value1"
											autoFocus={false}
											value={field.value}
											onChange={(e) => field.onChange(e)}
											className="input-height"
											type="number"
											disabled={
												!props.isEnrollVessel &&
												props.vesselMstId &&
												(props?.regulations?.trim() ===
													"EUMRV" ||
													"UKMRV" ||
													"DCS")
											}
											onKeyDown={(e) => {
												preventScientificNotation(e);
												// Prevent up and down arrow keys
												if (
													e.key === "ArrowUp" ||
													e.key === "ArrowDown"
												) {
													e.preventDefault();
												}
											}}
											onWheel={(e) => e.target.blur()}
										/>
									)}
								/>
								{errors.technicalEfficiency2 &&
									errors.technicalEfficiency2.input && (
										<div className="error-msg">
											{
												errors.technicalEfficiency2
													.input.message
											}
										</div>
									)}
							</MDBCol>
						) : (
							""
						)}
					</MDBRow>
				</MDBCol>
				<MDBCol md="12" className="mt-3">
					<Label required bold name="ICE Class?" />
					<MDBRow className="d-flex">
						<MDBCol
							md={
								iceClassName?.toLowerCase() ===
								ICECLASS_TYPE_OTHER
									? "6"
									: "12"
							}
						>
							<Controller
								name="regulationDetails.iceClass"
								control={control}
								rules={
									props?.regulations?.trim() !== "EUMRV" &&
									props?.regulations?.trim() !== "UKMRV" &&
									props?.regulations?.trim() !== "DCS"
										? {
												required:
													"Please enter an Ice Class, or NA for Not applicable",
										  }
										: {}
								}
								defaultValue={
									props?.vesselMstId ? enhancedIceClass : ""
								}
								render={({ field }) => (
									<div id="vessel_ice_class" name={field.name}>
										<AbsDropDown
											options={iceClasses}
											selected={field.value?.label}
											handleChange={(selectedItem) => {
												setIceClassName(
													selectedItem?.Value
												);
												field.onChange(selectedItem);
											}}
											placeholder="Please Select"
											disabled={
												!props.isEnrollVessel &&
												props.vesselMstId &&
												(props?.regulations?.trim() ===
													"EUMRV" ||
													"UKMRV" ||
													"DCS")
											}
										/>
									</div>
								)}
							/>
							{errors.regulationDetails &&
								errors.regulationDetails.iceClass && (
									<div className="error-msg">
										{
											errors.regulationDetails.iceClass
												.message
										}
									</div>
								)}
						</MDBCol>

						{iceClassName?.toLowerCase() ===
							ICECLASS_TYPE_OTHER && (
							<MDBCol md="6">
								<Controller
									name="regulationDetails.otherIceClassName"
									control={control}
									defaultValue={
										props.vesselMstId &&
										props.vesselData?.OtherIceClassName
											? props.vesselData
													?.OtherIceClassName
											: ""
									}
									rules={
										props?.regulations?.trim() !==
											"EUMRV" &&
										props?.regulations?.trim() !==
											"UKMRV" &&
										props?.regulations?.trim() !== "DCS"
											? {
													required:
														iceClassName?.toLowerCase() ===
														ICECLASS_TYPE_OTHER
															? "Please Enter Other Ice Class Name"
															: false,
											  }
											: {}
									}
									render={({ field }) => (
										<Input
											name={field.name}
											id="vessel_other_ice_class_name"
											autoFocus={false}
											required
											value={field.value}
											onChange={(e) => field.onChange(e)}
											className="input-height"
											maxLength={200}
											disabled={
												!props.isEnrollVessel &&
												props.vesselMstId &&
												(props?.regulations?.trim() ===
													"EUMRV" ||
													"UKMRV" ||
													"DCS")
											}
										/>
									)}
								/>
								{errors.regulationDetails &&
									errors.regulationDetails
										.otherIceClassName && (
										<div className="error-msg">
											{
												errors.regulationDetails
													.otherIceClassName.message
											}
										</div>
									)}
							</MDBCol>
						)}
					</MDBRow>
				</MDBCol>
				<MDBCol md="12" className="mt-3">
					<Label
						required
						bold
						name="Monitoring Method (Annual)"
						className="mb-1"
					/>
					<Controller
						name="regulationDetails.monitoringMethodPrimary"
						control={control}
						rules={
							props?.regulations?.trim() !== "EUMRV" &&
							props?.regulations?.trim() !== "UKMRV" &&
							props?.regulations?.trim() !== "DCS"
								? {
										required:
											"Please select monitoring method",
								  }
								: {}
						}
						defaultValue={
							props?.vesselMstId
								? enhancedMonitoringMethodPrimary
								: ""
						}
						render={({ field }) => (
							<div id="vessel_primary_monitoring_method" name={field.name}>
								<AbsDropDown
									options={monitoringMethods}
									selected={field.value?.label}
									handleChange={field.onChange}
									placeholder="Please Select"
									disabled={
										!props.isEnrollVessel &&
										props.vesselMstId &&
										(props?.regulations?.trim() ===
											"EUMRV" ||
											"UKMRV" ||
											"DCS")
									}
								/>
							</div>
						)}
					/>
					{errors.regulationDetails &&
						errors.regulationDetails.monitoringMethodPrimary && (
							<div className="error-msg">
								{
									errors.regulationDetails
										.monitoringMethodPrimary.message
								}
							</div>
						)}
				</MDBCol>
			</MDBRow>
		</div>
	);
};

export default memo(RegulationDetailsmFormGroup);
